(function () {
class $defd06e0b31da822$var$VariantSelects extends HTMLElement {
    constructor(){
        super();
        this.selectors = {
            formInput: ".js-lsg-pdp-form-input"
        };
        this.addEventListener('change', this.onVariantChange);
    }
    connectedCallback() {
        // Initialize with current variant on page load
        this.updateOptions();
        this.updateMasterId();
        if (this.currentVariant) this.updateAddToCartButton();
    }
    onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();
        this.updateSelectedSwatchValue(event);
        this.updateVariantStatuses();
        if (!this.currentVariant) this.setUnavailable();
        else {
            this.updateURL();
            this.updateVariantInput();
            this.updateAddToCartButton();
            this.updatePriceAndGallery();
        }
    }
    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select, fieldset'), (element)=>{
            if (element.tagName === 'SELECT') return element.value;
            if (element.tagName === 'FIELDSET') return Array.from(element.querySelectorAll('input')).find((radio)=>radio.checked)?.value;
        });
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant)=>{
            return !variant.options.map((option, index)=>{
                return this.options[index] === option;
            }).includes(false);
        });
    }
    updateSelectedSwatchValue({ target: target }) {
        const { value: value, tagName: tagName } = target;
        if (tagName === 'INPUT' && target.type === 'radio') {
            const selectedSwatchValue = target.closest(this.selectors.formInput).querySelector('[data-selected-value]');
            if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
    }
    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}`);
        productForms.forEach((productForm)=>{
            const input = productForm.querySelector('input[name="id"]');
            if (input) {
                input.value = this.currentVariant.id;
                input.dispatchEvent(new Event('change', {
                    bubbles: true
                }));
            }
        });
    }
    updateAddToCartButton() {
        if (!this.currentVariant) return;
        // Update all add-to-cart buttons in the section
        const addToCartButtons = document.querySelectorAll(`.b-pdp-hero__cta.trigger-add-to-cart, .b-pdp-sticky-cta .trigger-add-to-cart`);
        addToCartButtons.forEach((button)=>{
            button.setAttribute('data-product-id', this.currentVariant.id);
        });
    }
    updatePriceAndGallery() {
        if (!this.currentVariant) return;
        const requestedVariantId = this.currentVariant.id;
        const sectionId = this.dataset.section;
        const priceDestination = document.getElementById(`price-${sectionId}`);
        const galleryWrapperDestination = document.getElementById(`gallery-media-wrapper-${sectionId}`);
        const gallerySliderDestination = document.getElementById(`gallery-slider-${sectionId}`);
        const url = `${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`;
        fetch(url, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response)=>response.text()).then((responseText)=>{
            if (this.currentVariant.id !== requestedVariantId) return;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sectionWrapper = html.querySelector(`#shopify-section-${sectionId}`);
            // Update Price
            if (priceDestination) {
                let priceSource = html.getElementById(`price-${sectionId}`);
                if (!priceSource) priceSource = html.querySelector('.b-pdp-hero__price-wrapper');
                if (!priceSource && sectionWrapper) priceSource = sectionWrapper.querySelector(`#price-${sectionId}`) || sectionWrapper.querySelector('.b-pdp-hero__price-wrapper');
                if (priceSource) priceDestination.innerHTML = priceSource.innerHTML;
                else console.warn('Could not find price in section response', {
                    sectionId: sectionId,
                    variantId: requestedVariantId
                });
            }
            // Update Gallery
            if (galleryWrapperDestination || gallerySliderDestination) {
                let galleryWrapperSource = html.getElementById(`gallery-media-wrapper-${sectionId}`);
                let gallerySliderSource = html.getElementById(`gallery-slider-${sectionId}`);
                if ((!galleryWrapperSource || !gallerySliderSource) && sectionWrapper) {
                    galleryWrapperSource = galleryWrapperSource || sectionWrapper.querySelector(`#gallery-media-wrapper-${sectionId}`) || sectionWrapper.querySelector('.b-pdp-hero__media-wrapper');
                    gallerySliderSource = gallerySliderSource || sectionWrapper.querySelector(`#gallery-slider-${sectionId}`) || sectionWrapper.querySelector('.b-pdp-hero-media-slider')?.parentElement;
                }
                if (galleryWrapperSource && galleryWrapperDestination) galleryWrapperDestination.innerHTML = galleryWrapperSource.innerHTML;
                if (gallerySliderSource && gallerySliderDestination) {
                    gallerySliderDestination.innerHTML = gallerySliderSource.innerHTML;
                    // Reinitialize slider
                    const sliderElement = gallerySliderDestination.querySelector('.b-pdp-hero-media-slider__slider');
                    if (sliderElement && sliderElement.swiper) sliderElement.swiper.destroy(true, true);
                    if (window.initMediaPDPSlider) window.initMediaPDPSlider();
                    else if (window.initMediaPDP) window.initMediaPDP();
                    else window.dispatchEvent(new CustomEvent('galleryUpdated', {
                        detail: {
                            sectionId: sectionId
                        }
                    }));
                }
                if ((!galleryWrapperSource || !gallerySliderSource) && (galleryWrapperDestination || gallerySliderDestination)) console.warn('Could not find gallery in section response', {
                    sectionId: sectionId,
                    variantId: requestedVariantId
                });
            }
        }).catch((error)=>{
            console.error('Error updating price and gallery:', error);
        });
    }
    updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter((variant)=>this.querySelector(':checked').value === variant.option1);
        const inputWrappers = [
            ...this.querySelectorAll(this.selectors.formInput)
        ];
        inputWrappers.forEach((option, index)=>{
            if (index === 0) return;
            const optionInputs = [
                ...option.querySelectorAll('input[type="radio"], option')
            ];
            const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
            const availableOptionInputsValue = selectedOptionOneVariants.filter((variant)=>variant.available && variant[`option${index}`] === previousOptionSelected).map((variantOption)=>variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
    }
    setInputAvailability(elementList, availableValuesList) {
        elementList.forEach((element)=>{
            const value = element.getAttribute('value');
            const availableElement = availableValuesList.includes(value);
            if (element.tagName === 'INPUT') element.classList.toggle('disabled', !availableElement);
            else if (element.tagName === 'OPTION') element.innerText = availableElement ? value : window.variantStrings.unavailable_with_option.replace('[value]', value);
        });
    }
    setUnavailable() {
    // Handle unavailable variant state if needed
    }
    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}
customElements.define('lsg-variant-selects', $defd06e0b31da822$var$VariantSelects);

})();
